<div style="display: flex; flex-direction: column; gap: 5px">
	@for (booking of bookings; track booking) {
	<button mat-stroked-button (click)="navigateToBooking(booking.id)">
		<span [ngStyle]="findFilter(booking) ? { 'background-color': 'yellow' } : {}">
			<div
				*ngIf="booking.status != 'CONF' && booking.status != 'COMP'"
				style="display: flex; justify-content: space-between; align-items: center; gap: 5px"
			>
				<span>({{ booking.passengers?.length }}) {{ booking.contactName }}</span>
				@if (hasDefaultWeights(booking)) {
					<mat-icon color="warn" matTooltip="{{ 'BOOKINGS.default_weight_warning' | translate }}">scale</mat-icon>
				}
				<mat-icon [ngClass]="booking.iconColor === 'accent' ? 'mat-accent-icon' : ''">{{ booking.icon }}</mat-icon>
			</div>
			<div *ngIf="booking.status === 'CONF'" style="display: flex; justify-content: space-between; align-items: center; gap: 5px">
				<span>({{ booking.passengers?.length }}) {{ booking.contactName }}</span>
				@if (hasDefaultWeights(booking)) {
					<mat-icon color="warn" matTooltip="{{ 'BOOKINGS.default_weight_warning' | translate }}">scale</mat-icon>
				}
			</div>
			<div *ngIf="booking.status === 'COMP'" style="display: flex; justify-content: space-between; align-items: center; gap: 5px">
				<span>({{ booking.passengers?.length }}) {{ booking.contactName }}</span>
				@if (hasDefaultWeights(booking)) {
					<mat-icon color="warn" matTooltip="{{ 'BOOKINGS.default_weight_warning' | translate }}">scale</mat-icon>
				}
			</div>
		</span>
	</button>
	}
</div>
